// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import './styles/common.less';
import { YRouter } from '@ywfe/router';
import { getHost } from '@ywfe/utils';
import App from './App';
import { useGetAPI22504 } from './generated/api';

const isLogin = window.location.href.includes('/login');
const { basePath = '' } = getHost('PROAUTH', '88');
if (isLogin) {
  ReactDOM.render(
    <YRouter config={{ useGetModuleDataByName: useGetAPI22504 }}>
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
    </YRouter>,
    document.getElementById('ywApp'),
  );
} else {
  // 17020002 和 1000两个code都表示token失效
  const isTokenLose: (code: number) => boolean = (code) => code === 17020002 || code === 1000;
  // 在渲染之前判断一下当前的token是否有效,如果不生效则直接跳转login
  fetch(`${basePath}/ywwl-admin/user/current/info`, {
    headers: {
      'X-TOKEN': window.localStorage.getItem('token') || '',
    },
  })
    .then((res) => res.json())
    .then((data: { success: boolean; code: number }) => {
      if (!data.success && isTokenLose(data.code) && !isLogin) {
        const now_url = new URL(window.location.href);
        const LOGIN_CODE = now_url.searchParams.get('code');
        const FROMPLAT = now_url.searchParams.get('fromPlat');
        const state = now_url.searchParams.get('state');
        const isInFeishu = /Lark/i.test(navigator.userAgent);
        if (LOGIN_CODE) {
          window.location.href = `/login?targetUrl=${encodeURIComponent(window.location.href)}&code=${LOGIN_CODE}`;
          return;
        }
        // 中转页跳转免登（飞书）
        if (LOGIN_CODE && (state === 'FEISHU' || FROMPLAT === 'FEISHU')) {
          window.location.href = `/login?targetUrl=${encodeURIComponent(window.location.href)}&code=${LOGIN_CODE}&feishu=1`;
          return;
        }
        // app免登（飞书）
        if (isInFeishu && window?.h5sdk) {
          const client_id = env === 'prod' ? 'cli_a62218cb676e500c' : 'cli_a62a02c9c5b6d013';
          window.h5sdk.error((err) => {
            console.log(`error: ${JSON.stringify(err)}`);
          });
          window.h5sdk.ready(() => {
            // ready 方法不需要每次都调用。
            tt.requestAccess({
              scopeList: [],
              appID: client_id, // 网页应用必传
              success(res) {
                window.location.replace(`/login?targetUrl=${encodeURIComponent(window.location.href)}&code=${res?.code}&feishu=1`);
              },
              fail(res) {
                console.log(`requestAccess fail: ${JSON.stringify(res)}`);
              },
            });
          });
          return;
        }
        window.location.href = `/login?targetUrl=${encodeURIComponent(window.location.href)}`;
        return;
      }
      ReactDOM.render(
        <YRouter config={{ useGetModuleDataByName: useGetAPI22504 }}>
          <ConfigProvider locale={zhCN}>
            <App />
          </ConfigProvider>
        </YRouter>,
        document.getElementById('ywApp'),
      );
    })
    .catch((e) => {
      console.error(e);
    });
}
